import { CompassCardUI } from '@scale/compass-ui/types';
import {
  AudioTranscriptionModel,
  TranscribeAudioContext,
  TranscribeAudioCardShared,
  TranscribeAudioSchemaType,
  TRANSCRIBE_AUDIO,
} from '@scale/genai-compass-shared/cards/transcribe_audio';
import { faWaveformLines } from '@fortawesome/pro-solid-svg-icons';
import TranscribeAudioCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/TranscribeAudioCard/TranscribeAudioCardComponent';

const defaultContext: TranscribeAudioContext = {
  cardType: TRANSCRIBE_AUDIO,
  columns: [],
  model: AudioTranscriptionModel.AWS,
  enableSpeakerDiarization: false,
};

export const TranscribeAudioCardInfo: CompassCardUI<TranscribeAudioSchemaType> = {
  ...TranscribeAudioCardShared,
  title: 'Transcribe Audio',
  icon: 'waveform-lines',
  toolTip: 'Transcribe audio for tasks',
  defaultContext,
  button: {
    icon: faWaveformLines,
  },
  legacyComponent: TranscribeAudioCardComponent,
};
